module.exports = __webpack_public_path__ + "assets/media/evening.c415fda0.mp3";